<template>
<div class="view">
  <decorate></decorate>
  <div class="main bank_page">
    <div class="nav">
      <div class="left">
        <router-link
          class="front icon_back"
          :to="{
            path: '/selfInfo/2',
            query: {
              uid: queryData.uid,
              userId: queryData.userId,
              appId: queryData.appId,
              TopHeight: queryData.TopHeight,
            },
          }"
        ></router-link>
      </div>
      修改提现信息
    </div>
    <van-field
      autosize
      clearable
      readonly
      label="银行名称："
      placeholder="请输入银行名称"
      v-model="bankname"
      @click="onSelAddr()"
    />
    <van-field
      autosize
      clearable
      label="开户行："
      placeholder="请输入开户行地址"
      v-model="bankaddress"
    />
    <van-field
      autosize
      clearable
      type="tel"
      label="银行卡号码："
      placeholder="请输入银行卡号码"
      v-model="banknumber"
    />
    <van-field
      autosize
      clearable
      label="持卡人姓名："
      placeholder="请输入银行卡持卡人姓名"
      v-model="username"
    />
    <van-field
      autosize
      clearable
      label="银行预留号码："
      placeholder="请输入银行预留号码"
      v-model="telephone"
    />
    <van-popup v-model="showLocat" position="bottom" get-container="body">
      <van-area
        :area-list="areaList"
        :columns-num="1"
        @confirm="setArea"
        @cancel="onAddrCancel"
      />
    </van-popup>
    <div class="submit" @click="getBank()">提交</div>
  </div>
  </div>
</template>
    <script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import Vue from "vue";
import { Field, Area, Popup, Icon, Toast } from "vant";
import decorate from './element/decorate'
import "../css/aside.scss";
Vue.use(Field).use(Area).use(Popup).use(Icon);
export default {
  components: {decorate},
  data: function () {
    return {
      topHeight: 0,
      areaList: {
        province_list: {
          1: "农业银行",
          2: "建设银行",
          3: "中国银行",
          4: "工商银行",
          5: "交通银行",
          6: "上海浦发银行",
          7: "光大银行",
          8: "招商银行",
          9: "邮政储蓄银行",
        },
      },
      showLocat: false,
      bankname: "",
      telephone: "",
      bankaddress: "",
      username: "",
      banknumber: "",
    };
  },
  computed: {
    ...mapState(["homePage"]),
  },
  watch: {},
  created() {
    this.queryData = this.$route.query || {};
    this.topHeight = this.queryData.TopHeight;
    let obj = {
      bankId: this.queryData.bankId,
    };
    console.log(obj);
    this.$store.dispatch("homePage/fetchBankDetail", obj).then((res) => {
      this.bankname = res.bank_name;
      this.bankaddress = res.bank;
      this.banknumber = res.number;
      this.telephone = res.phone;
      this.username = res.name;
    });
  },
  methods: {
    ...mapActions(["fetchHome"]),
    ...mapMutations([]),

    onSelAddr() {
      this.showLocat = true;
    },
    setArea(val) {
      this.bankname = val[0].name;
      this.showLocat = false;
    },
    onAddrCancel() {
      this.showLocat = false;
    },

    getBank() {
      if (this.bankname == "") {
        Toast({
          message: "请输入银行名称",
        });
        return false;
      }
      if (this.bankaddress == "") {
        Toast({
          message: "请输入开户行地址",
        });
        return false;
      }
      if (this.banknumber == "") {
        Toast({
          message: "请输入银行卡号码",
        });
        return false;
      }
      let bankreg = /^(\d{16}|\d{17}|\d{18}|\d{19})$/;
      if (!bankreg.test(this.banknumber)) {
        Toast({
          message: "请输入正确银行卡号码",
        });
        return false;
      }
      if (this.username == "") {
        Toast({
          message: "请输入持卡人姓名",
        });
        return false;
      }
      if (this.telephone == "") {
        Toast({
          message: "请输入银行预留号码",
        });
        return false;
      }
      let phone = /^1[3456789]\d{9}$/;
      if (!phone.test(this.telephone)) {
        Toast({
          message: "请输入正确银行预留号码",
        });
        return false;
      }

      let obj = {
        userId: this.queryData.userId,
        name: this.username,
        phone: this.telephone,
        bank: this.bankaddress,
        number: this.banknumber,
        bankName: this.bankname,
        bankId: this.queryData.bankId,
      };
      // console.log(obj)
      this.$store.dispatch("homePage/fetchEditBank", obj).then(() => {
        this.$dialog({
          title: "提醒",
          message: "修改提现成功",
        }).then(() => {
          this.$router.push({
            path: "/selfInfo",
            name: "selfInfo",
            query: this.queryData,
            params: { statusTab: 2 },
          });
        });
      });
    },
  },
  mounted() {
    // const self=this;
    // this.$refs.view.scroll.on('scroll',(position)=>{
    //     self.$parent.scrollY=position.y;
    // })
  },
};
</script>
    